import { render, staticRenderFns } from "./dialog-confirmdeleterenamedocument.vue?vue&type=template&id=ae19de2e&"
import script from "./dialog-confirmdeleterenamedocument.vue?vue&type=script&lang=js&"
export * from "./dialog-confirmdeleterenamedocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports